import { ApolloError } from '@apollo/client';

import { ScanDataSftpCredentialsOverviewFragment } from '@occc/graphql';

import { GenericSubmissionGroup } from './scan-data-submission-groups.types';
import { SubmissionGroupsOverview } from './components/submission-groups-overview';
import { RJRSubmissionGroupsTable } from './components/rjr-submission-groups-table';
import { AltriaSubmissionGroupsTable } from './components/altria-submission-groups-table';
import { MSASubmissionGroupsTable } from './components/msa-submission-groups-table';

import { LoadedDataWithPagination } from '../../scan-data.types';

type ScanDataSubmissionGroupsProps = {
  overviewData?: ScanDataSftpCredentialsOverviewFragment;
  overviewLoading: boolean;
  overviewError?: ApolloError;
  showActions: boolean;
  altriaLoadedDataWithPagination: LoadedDataWithPagination<GenericSubmissionGroup[]>;
  msaLoadedDataWithPagination: LoadedDataWithPagination<GenericSubmissionGroup[]>;
  rjrLoadedDataWithPagination: LoadedDataWithPagination<GenericSubmissionGroup[]>;
};

export const ScanDataSubmissionGroups = ({
  overviewData,
  overviewLoading,
  overviewError,
  showActions,
  altriaLoadedDataWithPagination,
  msaLoadedDataWithPagination,
  rjrLoadedDataWithPagination,
}: ScanDataSubmissionGroupsProps) => {
  return (
    <>
      <SubmissionGroupsOverview
        data={overviewData}
        loading={overviewLoading}
        error={overviewError}
      />

      <RJRSubmissionGroupsTable {...rjrLoadedDataWithPagination} showActions={showActions} />

      <AltriaSubmissionGroupsTable {...altriaLoadedDataWithPagination} showActions={showActions} />

      <MSASubmissionGroupsTable {...msaLoadedDataWithPagination} showActions={showActions} />
    </>
  );
};
